module.exports = __webpack_public_path__ + "static/Union-1b28310a3d5d37b9a158b565a37f8024.svg";